import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndPointApi } from '@helpers/endpointapi';
import { lastValueFrom } from 'rxjs';
import { EnvironmentService } from './environment.service';
import { RuntimeEnvironments } from '../models/runtime-enviroment.enum';

@Injectable({
    providedIn: 'root',
})
export class UserCompanyService {
    private domain: string;
    private headers: any = new HttpHeaders({
        'Content-Type': 'application/json',
    });
    private env: RuntimeEnvironments;

    constructor(
        private http: HttpClient,
        private environmentService: EnvironmentService
    ) {
        this.domain = EndPointApi.iApiDomain();
        this.env = this.environmentService.getEnvironment();
    }

    async getUsersCompany(currentUserOid): Promise<{ name: string; email: string; oid: string }[]> {
        if (this.env == RuntimeEnvironments.ELECTRON) return [];

        return await lastValueFrom(this.http.get<any>(`${this.domain}/api/companyUsers/${currentUserOid}`));
    }

    async getUserInfo(userOid): Promise<{ name: string; email: string; oid: string }> {
        if (this.env == RuntimeEnvironments.ELECTRON) return;
        const userInfo = await lastValueFrom(this.http.get<any>(`${this.domain}/api/user/${userOid}`));
        return userInfo;
    }
}
